import { call, put, select, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';
import getProductId from '../../selectors/product';

export function* getDefaultCourses() {
    const productId = yield select(getProductId);
    const payload = yield call(api.getDefaultCourses, { productId });
    if (payload.status === 200) {
        yield put(actions.getDefaultCoursesSuccess(payload.data));
    } else {
        yield put(actions.getDefaultCoursesFailure());
    }
}

export function* getDefaultCoursesSaga() {
    yield takeLatest(actions.GET_DEFAULT_COURSE_REQUEST, getDefaultCourses);
}

export function* fetchingCourseDetails() {
    const state = yield select();
    const { selectedCourseId: courseId } = state.defaultCourses;
    const payload = yield call(api.getCourse, { courseId });
    if (payload.status === 200) {
        yield put(actions.fetchCourseDetailsSuccess(payload.data));
    } else {
        yield put(actions.fetchCourseDetailsFailure());
    }
}

export function* fetchingCourseDetailsSaga() {
    yield takeLatest(actions.FETCH_COURSE_DETAILS_REQUEST, fetchingCourseDetails);
}

export function* showCourseDetails({ courseId }) {
    yield put(actions.fetchCourseDetails(courseId));
}

export function* showCourseDetailsSaga() {
    yield takeLatest(actions.SHOW_COURSE_DETAILS, showCourseDetails);
}

export function* saveDefaultCourses({ yearGroupCourses }) {
    const productId = yield select(getProductId);
    const response = yield call(api.saveSchoolDefaultCourses, productId, yearGroupCourses);
    if (response.status === 200) {
        yield put(actions.saveDefaultCoursesSuccess(false));
    } else {
        yield put(actions.saveDefaultCoursesFailure(false));
    }
}

export function* saveDefaultCoursesSaga() {
    yield takeLatest(actions.SAVE_DEFAULT_COURSE_REQUEST, saveDefaultCourses);
}



// WEBPACK FOOTER //
// ./app/containers/default-course/saga.js